module.exports = __webpack_public_path__ + "static/media/Like2.bdcab2dc.gif";